import {
  Card,
  Grid,
  Typography,
  Paper,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import RoomRoundedIcon from '@mui/icons-material/RoomRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import style from "./cardsDetails.module.scss";
import moment from "moment-timezone";
import SensorDoorIcon from "@mui/icons-material/SensorDoor";
import eggs from "../../assets/egg.png";
import chicken from "../../assets/chick.png";
import time from "../../assets/cronometro.png";
import openDoor from "../../assets/abertura-da-porta-aberta.png";
import embryo from '../../assets/embriao.png';
import no_image from '../../assets/sem_imagem.png';
moment.locale("pt-br");

moment.updateLocale("pt-br", {
  relativeTime: {
    future: "%s",
    past: "%s",
    s: "s",
    ss: "%d s",
    m: "min",
    mm: "%d min",
    h: "h",
    hh: "%d h",
    d: "dias",
    dd: "%d dias",
    w: "semana",
    ww: "%d semanas",
    M: "mês",
    MM: "%d messes",
    y: "ano",
    yy: "%d anos",
  },
});

export const CardsDetails = ({ element, index, sizeXl }) => {
  const isFullScreen = sizeXl === 2;

  const handleOpenMaps = (lat, lng) => {
    const url = `https://www.google.com.br/maps?q=${lat},${lng}`;
    window.open(url, "_blank");
  };

  function formatTimeElapsed(dateTime) {
    const now = moment();
    const duration = moment.duration(now.diff(moment(dateTime)));

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    if (days > 0) {
      return `${days}d${hours}h`;
    }
    if (hours > 0) {
      return `${hours}h${minutes}m`;
    }
    if (minutes > 0) {
      return `${minutes}m${seconds}s`;
    }
    return `${minutes}m${seconds}s`;
  }

  function getColorBasedOnTime(dateTime) {
    const now = moment();
    const hoursElapsed = moment
      .duration(now.diff(moment(dateTime)))
      .asMinutes();
    if (hoursElapsed > 360) {
      return "#D60000";
    } else if (hoursElapsed > 15 && hoursElapsed < 360) {
      return "#E66500";
    } else {
      return "black";
    }
  }

  function TimeAgo({ dateTime }) {
    const color = getColorBasedOnTime(dateTime);
    return (
      <Tooltip title="Tempo da Última Atualização">
        <Typography
          style={{
            fontSize: isFullScreen ? "12px" : "15px",
            color: color,
            fontWeight: "bold",
            marginTop: isFullScreen ? "0px" : "2px",
          }}
        >
          {formatTimeElapsed(dateTime)}
        </Typography>
      </Tooltip>
    );
  }

  const textPlateColor =
    element.isTempInt1SuperCritical ||
      element.isHum1SuperCritical ||
      element.isCO2SuperCritical ||
      element.isVibraSuperCritical ||
      element.isTrunkVoltageSuperCritical
      ? 1
      : element.isTempInt1Critical ||
        element.isHum1Critical ||
        element.isCO2Critical ||
        element.isVibraCritical
        ? 2
        : 3;

  return (
    <Card className={isFullScreen ? style.configCard : style.configCardReduce}>
      <Grid className={style.configGrid} container>
        <Grid
          xl={12}
          xs={12}
          lg={12}
          sm={12}
          style={{
            marginTop: "5px",
            marginRight: "5px",
            marginLeft: "5px",
          }}

        >
          <Paper
            className={
              isFullScreen
                ? style.configPaperPlate
                : style.configPaperPlateReduce
            }
            elevation={4}
          >
            <Grid
              item
              xl={2}
              xs={2}
              lg={2}
              sm={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Tooltip
                title={
                  element.typeOperation === "OVOS" ? "Ovos" : element.typeOperation === "PINTOS" ? "Pintinhos" :
                    element.typeOperation === "EMBRIÕES" ? "Embriões" : ""
                }
                placement="top"
              >
                {(() => {
                  switch (element.typeOperation) {
                    case "OVOS":
                      return (
                        <img
                          src={eggs}
                          alt="Ícone"
                          style={{
                            height: isFullScreen ? "25px" : "25px",
                            width: isFullScreen ? "25px" : "25px",
                          }}
                        />
                      );
                    case "PINTOS":
                      return (
                        <img
                          src={chicken}
                          alt="Ícone"
                          style={{
                            height: isFullScreen ? "30px" : "28px",
                            width: isFullScreen ? "30px" : "28px",
                          }}
                        />
                      ); case "EMBRIÕES":
                      return (
                        <img
                          src={embryo}
                          alt="Ícone"
                          style={{
                            height: isFullScreen ? "27px" : "25px",
                            width: isFullScreen ? "27px" : "25px",
                          }}
                        />
                      );
                    default:
                      return (
                        <img
                          src={no_image}
                          alt="Ícone"
                          style={{
                            height: isFullScreen ? "40px" : "38px",
                            width: isFullScreen ? "40px" : "38px",
                          }}
                        />
                      )
                    // outros casos
                  }
                })()}
              </Tooltip>
            </Grid>

            <Grid
              xl={12}
              xs={12}
              lg={12}
              sm={12}
              item
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Tooltip title="Placa">
                {isFullScreen ? (
                  <Button
                    variant="text"
                    disableElevation
                    className={style.buttonText}
                  >
                    <Typography
                      className={
                        textPlateColor === 1
                          ? style.textPlateSuperCritical
                          : textPlateColor === 2
                            ? style.textPlateCritical
                            : style.textPlate
                      }
                      style={{ fontSize: element.vehiclePlate.length > 7 ? "14px" : "28px" }}
                    >
                      {element.vehiclePlate}
                    </Typography>
                  </Button>
                ) : (
                  <Button
                    variant="text"
                    disableElevation
                    className={style.buttonText}
                  >
                    <Typography
                      className={
                        textPlateColor === 1
                          ? style.textPlateSuperCriticalReduce
                          : textPlateColor === 2
                            ? style.textPlateCriticalReduce
                            : style.textPlateReduce
                      }
                      style={{ fontSize: element.vehiclePlate.length > 7 ? "16px" : "32px" }}
                    >
                      {element.vehiclePlate}
                    </Typography>
                  </Button>
                )}
              </Tooltip>

              <Grid
                item
                xl={12}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginTop: "5px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip
                    title={"Tempo da Última Atualização"}
                    placement="bottom"
                  >
                    {(() => {
                      return (
                        <img
                          src={time}
                          alt="Ícone"
                          style={{
                            height: isFullScreen ? "18px" : "20px",
                            width: isFullScreen ? "18px" : "20px",
                            marginBottom: "3px"
                          }}
                        />
                      );
                    })()}
                  </Tooltip>
                  <TimeAgo dateTime={element.dateTimeLastUpdate} />
                </div>

                <Tooltip title="Última posição">
                  <IconButton
                    style={{
                      color: "#2899FD",
                      height: isFullScreen ? "25px" : "20px",
                      width: isFullScreen ? "20px" : "15px",
                      marginTop: isFullScreen ? "2px" : "0px",
                    }}
                    onClick={() =>
                      handleOpenMaps(element.latitude, element.longitude)
                    }
                    size="medium"
                  >
                    <RoomRoundedIcon
                      style={{ fontSize: isFullScreen ? "20px" : "24px" }}
                    ></RoomRoundedIcon>
                  </IconButton>
                </Tooltip>

                {element.thermoKing === "ON" ? (
                  <Tooltip title="Climatização Ligada">
                    <AcUnitRoundedIcon
                      style={{
                        fontSize: isFullScreen ? "20px" : "22px",
                      }}
                      color={"success"}
                    ></AcUnitRoundedIcon>
                  </Tooltip>
                ) : element.thermoKing === "OFF" ? (
                  <Tooltip title="Climatização Desligada">
                    <AcUnitRoundedIcon
                      style={{
                        fontSize: isFullScreen ? "20px" : "22px",
                        color: "black",
                      }}
                    ></AcUnitRoundedIcon>
                  </Tooltip>
                ) : (element.status === 1 || element.status === 2) &&
                  (element.thermoKing === "OFF" ||
                    element.thermoKing === "OFF_ATTENTION") ? (
                  <Tooltip title="Climatização Desligada, mas com carga">
                    <AcUnitRoundedIcon
                      className={
                        element.stopStatus === 0 && element.ignition === true
                          ? style.iconPulse
                          : null
                      }
                      style={{
                        fontSize: isFullScreen ? "20px" : "22px",
                      }}
                      color={"error"}
                    ></AcUnitRoundedIcon>
                  </Tooltip>
                ) : (
                  <></>
                )}

                {element.isDoorOpen ? (
                  <Tooltip title="Porta Fechada">
                    <SensorDoorIcon
                      style={{
                        fontSize: isFullScreen ? "20px" : "22px",
                        marginTop: "1px",
                      }}
                      color={"success"}
                    ></SensorDoorIcon>
                  </Tooltip>
                ) : (
                  <Tooltip title="Porta Aberta">
                    {(() => {
                      return (
                        <img
                          src={openDoor}
                          alt="Ícone"
                          style={{
                            height: isFullScreen ? "19px" : "17px",
                            width: isFullScreen ? "19px" : "17px",
                            marginTop: isFullScreen ? "0px" : "0px",
                          }}
                        />
                      ); // outros casos
                    })()}
                  </Tooltip>
                )}

                {element.stopStatus === 0 && element.ignition ? (
                  <Tooltip title="Caminhão em Movimento">
                    <LocalShippingRoundedIcon
                      style={{
                        fontSize: isFullScreen ? "22px" : "25px",
                        color: "green",
                      }}
                      color={"success"}
                    ></LocalShippingRoundedIcon>
                  </Tooltip>
                ) : element.stopStatus !== 0 && element.ignition ? (
                  <Tooltip title="Caminhão Parado/Ligado">
                    <LocalShippingRoundedIcon
                      style={{
                        fontSize: isFullScreen ? "22px" : "25px",
                        color: "orange",
                      }}
                    ></LocalShippingRoundedIcon>
                  </Tooltip>
                ) : (
                  <Tooltip title="Caminhão Parado/Desligado">
                    <LocalShippingRoundedIcon
                      style={{
                        fontSize: isFullScreen ? "22px" : "25px",
                        color: "red",
                      }}
                    ></LocalShippingRoundedIcon>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>


      <Grid container className={style.configGrid} style={{ marginTop: "15px" }}>
        <Grid item xl={6} xs={6} lg={6} sm={6}>
          <Typography
            className={
              isFullScreen ? style.textVariables : style.textVariablesReduce
            }
          >
            Temp. Ext.
          </Typography>
        </Grid>
        <Grid
          item
          xl={3}
          xs={3}
          lg={3}
          sm={3}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            marginRight: '10px',
            alignItems: "flex-end",
          }}
        >
        </Grid>
        <Grid
          item
          xl={6}
          xs={6}
          lg={6}
          sm={isFullScreen ? 6 : 8}
          style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}
        >
          <Grid
            item
            xl={8}
            xs={8}
            lg={8}
            sm={8}
            style={{ marginLeft: isFullScreen ? "2px" : "5px" }}
          >
            <Tooltip title="Temperatura Externa" placement='top-start'>
              <Paper
                className={
                  isFullScreen ? style.configPaper : style.configPaperReduce
                }
                elevation={2}
              >
                <Typography
                  className={
                    isFullScreen ? style.textValues : style.textValuesReduce
                  }
                >
                  {element.temperatureExt.toFixed(2)}
                </Typography>
              </Paper>
            </Tooltip>
          </Grid>

          <Grid item xl={3} xs={3} lg={3} sm={3}>
            <Typography
              style={{
                fontSize: isFullScreen ? "12px" : "16px",
                color: "white",
                fontWeight: "700",
                marginLeft: "5px",
              }}
            >
              ºC
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        className={style.configGrid}
        style={{ marginTop: "10px" }}
      >
        <Grid item xl={6} xs={6} lg={6} sm={6}>
          <Typography
            className={
              isFullScreen ? style.textVariables : style.textVariablesReduce
            }
          >
            Temp. Int.
          </Typography>
        </Grid>
        <Grid
          item
          xl={3}
          xs={3}
          lg={3}
          sm={3}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            marginLeft: '8px',
            marginRight: "3px",
            alignItems: "flex-end",
          }}
        >
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Mín. {element.thresholdMinTemp}
          </Typography>
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Máx. {element.thresholdMaxTemp}
          </Typography>
        </Grid>
        <Grid
          item
          xl={6}
          xs={6}
          lg={6}
          sm={isFullScreen ? 6 : 8}
          style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}
        >
          <Grid
            item
            xl={8}
            xs={8}
            lg={8}
            sm={8}
            style={{ marginLeft: isFullScreen ? "2px" : "5px" }}
          >
            {isFullScreen ? (
              <Tooltip title="Temperatura Interna Média" placement='top-start'>
                <Paper className={style.configPaper} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isTempInt1SuperCritical
                        ? style.textValuesSuperCritical
                        : element.isTempInt1Critical
                          ? style.textValuesCritical
                          : style.textValues
                    }
                  >
                    {element.averageTemperature.toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            ) : (
              <Tooltip title="Temperatura Interna Média" placement='top-start'>
                <Paper className={style.configPaperReduce} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isTempInt1SuperCritical
                        ? style.textValuesSuperCriticalReduce
                        : element.isTempInt1Critical
                          ? style.textValuesCriticalReduce
                          : style.textValuesReduce
                    }
                  >
                    {element.averageTemperature.toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            )}
          </Grid>
          <Grid item xl={3} xs={3} lg={3} sm={3}>
            <Typography
              style={{
                fontSize: isFullScreen ? "12px" : "16px",
                color: "white",
                fontWeight: "700",
                marginLeft: "5px",
              }}
            >
              ºC
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container className={style.configGrid} style={{ marginTop: "10px" }}>
        <Grid item xl={6} xs={6} lg={6} sm={6}>
          <Typography
            className={
              isFullScreen ? style.textVariables : style.textVariablesReduce
            }
          >
            Umid. Int.
          </Typography>
        </Grid>
        <Grid
          item
          xl={3}
          xs={3}
          lg={3}
          sm={3}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            marginLeft: '8px',
            marginRight: "3px",
            alignItems: "flex-end",
          }}
        >
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Mín. {element.thresholdMinHum}
          </Typography>
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Máx. {element.thresholdMaxHum}
          </Typography>
        </Grid>
        <Grid
          item
          xl={6}
          xs={6}
          lg={6}
          sm={isFullScreen ? 6 : 8}
          style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}
        >
          <Grid
            item
            xl={8}
            xs={8}
            lg={8}
            sm={8}
            style={{ marginLeft: isFullScreen ? "2px" : "5px" }}
          >
            {isFullScreen ? (
              <Tooltip title="Umidade Interna Média" placement='top-start'>
                <Paper className={style.configPaper} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isHum1SuperCritical
                        ? style.textValuesSuperCritical
                        : element.isHum1Critical
                          ? style.textValuesCritical
                          : style.textValues
                    }
                  >
                    {element.averageHumidity.toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            ) : (
              <Tooltip title="Umidade Interna Média" placement='top-start'>
                <Paper className={style.configPaperReduce} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isHum1SuperCritical
                        ? style.textValuesSuperCriticalReduce
                        : element.isHum1Critical
                          ? style.textValuesCriticalReduce
                          : style.textValuesReduce
                    }
                  >
                    {element.averageHumidity.toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            )}
          </Grid>
          <Grid item xl={3} xs={3} lg={3} sm={3}>
            <Typography
              style={{
                fontSize: isFullScreen ? "12px" : "16px",
                color: "white",
                fontWeight: "700",
                marginLeft: "8px",
              }}
            >
              %
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container className={style.configGrid} style={{ marginTop: "10px" }}>
        <Grid item xl={5} xs={5} lg={5} sm={5}>
          <Typography
            className={
              isFullScreen ? style.textVariables : style.textVariablesReduce
            }
          >
            CO2. Int.
          </Typography>
        </Grid>
        <Grid
          item
          xl={4}
          xs={4}
          lg={4}
          sm={4}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Mín. {element.thresholdMinCO2}
          </Typography>
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Máx. {element.thresholdMaxCO2}
          </Typography>
        </Grid>
        <Grid
          item
          xl={6}
          xs={6}
          lg={6}
          sm={isFullScreen ? 6 : 8}
          style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}
        >
          <Grid
            item
            xl={8}
            xs={8}
            lg={8}
            sm={8}
            style={{ marginLeft: isFullScreen ? "5px" : "10px" }}
          >
            {isFullScreen ? (
              <Tooltip title="CO2 Interno" placement='top-start'>
                <Paper className={style.configPaper} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isCO2Critical
                        ? style.textValuesCritical
                        : element.isCO2SuperCritical
                          ? style.textValuesSuperCritical
                          : style.textValues
                    }
                  >
                    {element.firstCo2}
                  </Typography>
                </Paper>
              </Tooltip>
            ) : (
              <Tooltip title="CO2 Interno" placement='top-start'>
                <Paper className={style.configPaperReduce} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isCO2Critical
                        ? style.textValuesCriticalReduce
                        : element.isCO2SuperCritical
                          ? style.textValuesSuperCriticalReduce
                          : style.textValuesReduce
                    }
                  >
                    {element.firstCo2}
                  </Typography>
                </Paper>
              </Tooltip>
            )}
          </Grid>
          <Grid item xl={3} xs={3} lg={3} sm={3}>
            <Typography
              style={{
                fontSize: isFullScreen ? "8px" : "10px",
                fontWeight: "700",
                color: "white",
                marginBottom: "0px",
                marginLeft: isFullScreen ? "4px" : "4px",
              }}
            >
              PPM
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container className={style.configGrid} style={{ marginTop: "10px" }}>
        <Grid item xl={6} xs={6} lg={6} sm={6}>
          <Typography
            className={
              isFullScreen ? style.textVariables : style.textVariablesReduce
            }
          >
            Vibração
          </Typography>
        </Grid>
        <Grid
          item
          xl={3}
          xs={3}
          lg={3}
          sm={3}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            marginLeft: '8px',
            marginRight: "3px",
            alignItems: "flex-end",
          }}
        >
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Mín. {element.thresholdMinVibr}
          </Typography>
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Máx. {element.thresholdMaxVibr}
          </Typography>
        </Grid>
        <Grid
          item
          xl={6}
          xs={6}
          lg={6}
          sm={isFullScreen ? 6 : 8}
          style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}
        >
          <Grid item xl={8} xs={8} lg={8} sm={8}>
            {isFullScreen ? (
              <Tooltip title="Vibração Interna" style={{ marginLeft: "2px" }} placement='top-start'>
                <Paper className={style.configPaper} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isVibraCritical
                        ? style.textValuesCritical
                        : element.isVibraSuperCritical
                          ? style.textValuesSuperCritical
                          : style.textValues
                    }>
                    {element.vibration1.toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            ) : (
              <Tooltip title="Vibração Interna" style={{ marginLeft: "5px" }} placement='top-start'>
                <Paper className={style.configPaperReduce} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isVibraCritical
                        ? style.textValuesCriticalReduce
                        : element.isVibraSuperCritical
                          ? style.textValuesSuperCriticalReduce
                          : style.textValuesReduce
                    }>
                    {element.vibration1.toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            )}
          </Grid>
          <Grid item xl={3} xs={3} lg={3} sm={3}>
            <Typography
              style={{
                fontSize: isFullScreen ? "12px" : "16px",
                color: "white",
                fontWeight: "700",
                marginLeft: isFullScreen ? "8px" : "8px",
              }}
            >
              G
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container className={style.configGrid} style={{ marginTop: "10px" }}>
        <Grid item xl={6} xs={6} lg={6} sm={6}>
          <Typography
            className={
              isFullScreen ? style.textVariables : style.textVariablesReduce
            }
          >
            Voltagem
          </Typography>
        </Grid>
        <Grid
          item
          xl={3}
          xs={3}
          lg={3}
          sm={3}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "column",
            marginRight: "3px",
            marginLeft: '8px',
            alignItems: "flex-end",
          }}
        >
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Mín. {parseFloat(element.trunkVoltage).toFixed(2) >= 17.00 ? 22 : 10}
          </Typography>
          <Typography
            className={
              isFullScreen ? style.textThreshold : style.textThresholdReduce
            }
          >
            Máx. {parseFloat(element.trunkVoltage).toFixed(2) >= 17.00 ? 29 : 15}
          </Typography>
        </Grid>
        <Grid
          item
          xl={6}
          xs={6}
          lg={6}
          sm={isFullScreen ? 6 : 8}
          style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}
        >
          <Grid
            item
            xl={8}
            xs={8}
            lg={8}
            sm={8}
            style={{ marginLeft: isFullScreen ? "2px" : "5px" }}
          >
            {isFullScreen ? (
              <Tooltip title="Voltagem">
                <Paper className={style.configPaper} elevation={2}>
                  <Typography
                    style={{ marginTop: "1px" }}
                    className={
                      element.isTrunkVoltageSuperCritical
                        ? style.textValuesSuperCritical
                        : style.textValues
                    }
                  >
                    {parseFloat(element.trunkVoltage).toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            ) : (
              <Tooltip title="Voltagem">
                <Paper className={style.configPaperReduce} elevation={2}>
                  <Typography style={{ marginTop: "1px" }} className={style.textValuesReduce}>
                    {parseFloat(element.trunkVoltage).toFixed(2)}
                  </Typography>
                </Paper>
              </Tooltip>
            )}
          </Grid>
          <Grid item xl={3} xs={3} lg={3} sm={3}>
            <Typography
              style={{
                fontSize: isFullScreen ? "12px" : "16px",
                color: "white",
                fontWeight: "700",
                marginLeft: "8px",
              }}
            >
              V
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};
